import { Box, ListItem, Text, UnorderedList } from "@chakra-ui/react";
import TourLayout from "../Layout/TourLayout";

export default function AssistantTour({ onCloseAssistantTour }) {
  return (
    <TourLayout onCloseTour={onCloseAssistantTour}>
      <Box fontSize={"md"}>
        <Text>
          An Assistant is the brain of your AI Agent. It brings together the
          data sources, users' queries, tools, and forms and orchestrates the
          end-to-end conversation with your users.
        </Text>
        <UnorderedList>
          <ListItem>
            <strong>Chat: </strong>Use them to deploy QnA chatbots. They excel
            at finding comprehensive answers based on your data sources and
            carry out business actions such as booking appointments.
          </ListItem>
          <ListItem>
            <strong>Phone: </strong>These are AI-enabled phone agents that can
            be used to make or receive phone calls. It can be used for making
            appointments, phone ordering, reminders and so much more.
          </ListItem>
          <ListItem>
            <strong>OpenAI Realtime: </strong>Use them to leverage OpenAI
            Realtime models.
          </ListItem>
        </UnorderedList>
      </Box>
    </TourLayout>
  );
}
